import SettingsHome from 'scripts/defa/settings-home/model-settings-home';

/**
 * defa.collections.SettingsHomes
 * A Collection of SettingsHomes with custom filters.
 * @version 1.2.0
 */
const SettingsHomes = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: SettingsHome,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new SettingsHomes collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {Collection}      The filtered SettingsHomesCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( model ) {
			return _.contains( ids, model.get( 'id' ) );
		} );
		
		return new SettingsHomes( array );
	},
	
} );

export default SettingsHomes;